import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberResearchProjects } from "./routeType";

const { key, getPath } = getApi("members.researchProject.get");

type IExtractedRouteType =
  IMemberResearchProjects["researchProjectSingleRetrieve"];

export type IGetMemberResearchProject = IPickSingleQuery<IExtractedRouteType>;

const getMemberResearchProject: Fetcher<
  IGetMemberResearchProject["response"],
  IGetMemberResearchProject["variables"]
> = ({ memberId, projectId, ...params }) => {
  return axiosClient.get(getPath({ memberId, projectId }), { params });
};

export const useGetMemberResearchProject = createQuery({
  queryKey: [key],
  fetcher: getMemberResearchProject,
});
